import React from 'react';

const loading = () => (
  <div className="loading">
    <p>...</p>
  </div>
);

export default loading;



// WEBPACK FOOTER //
// ./src/pages/Loading/index.js